import React, { useEffect, useState } from 'react';
import './MoreRecents.css';
import axios from 'axios';
import Product from './Product';
import { useStateValue } from './StateProvider';

function MoreRecents() {
    const [{ pagNum }, dispatch] = useStateValue();
    const [product, setProduct] = useState([]);
    const [pagIndex, setPagIndex] = useState(1);
    const [number_of_pag, setNumber_of_pag] = useState('');
    const [previous, setPrevious] = useState(1);
    const [next, setNext] = useState(1);
    var setPag = 1;
    var results_per_pag = 9;

    useEffect(() => {
        axios
            .get('https://toycityzimbabwe.com/backend/getRecentProduct.php')
            .then((res) => {
                number_of_results(res.data)
            })
            .catch( error => {
                console.log(error)
            });
      
    }, []);

    function number_of_results(results){
        var number_of_result = results.length;
        var number_of_pag = Math.ceil(number_of_result/results_per_pag);
        setNumber_of_pag(number_of_pag)
    }
    
    const moveDot = index => {
        setPagIndex(index)
        setPag = index;
        setNext(index);
        setPrevious(index);

        dispatch({
            type: "PAGNUM",
            pagNum: index,
        });
    }

    useEffect(() => {

        if(pagNum === 0)
            setPag = pagIndex;
        else
        {
            setPag = pagNum;
            moveDot(pagNum);
        }

        axios
            .get('https://toycityzimbabwe.com/backend/getAllRecentProduct.php', {params :{setPag, results_per_pag}})
            .then((res) => {
                setProduct(res.data)
            })
            .catch( error => {
                console.log(error)
            });
      
    }, [pagIndex])

    return (
        <div className='morerecents carts'>
            <h1>More Recents</h1>
            <div className="carts__cartrow">
                <div className="carts__carts">
                    {
                        product.map(item => (
                            <Product 
                                id = {item.id}
                                title={item.name}
                                price={item.price} 
                                img={item.img}
                                sold={item.sold}
                            />
                        ))
                    }
                </div>
                <div className='carts__pag'>
                    {(previous === 1) ? ' ' : (
                        
                        <button
                            onClick={() => moveDot(previous - 1)}
                            className='carts__btn'
                        >
                            Previous
                        </button>  
                    )}

                    {(number_of_pag === 0 || next === 0 ) ? ' ' : (
                        
                        <button
                            onClick={() => moveDot(next)}
                            className='carts__btn active'
                        >
                            {next}
                        </button>  
                    )}

                    {(number_of_pag === 0 || next === 0 || number_of_pag === next) ? ' ' : (
                        
                        <button
                            onClick={() => moveDot(next + 1)}
                            className='carts__btn'
                        >
                            {next + 1}
                        </button>  
                    )}

                    {(number_of_pag === 0 || next === 0 || (number_of_pag - 1) === next || number_of_pag === next) ? ' ' : (
                        
                        <button
                            onClick={() => moveDot(next + 2)}
                            className='carts__btn'
                        >
                            {next + 2}
                        </button>  
                    )}

                    {(number_of_pag === 0 || (number_of_pag === next)) ? ' ' : (
                        
                        <button
                            onClick={() => moveDot(next + 1)}
                            className='carts__btn'
                        >
                            Next
                        </button>  
                    )}
                </div>
            </div>
        </div>
    )
}

export default MoreRecents;